import { JobProfileSelectItem, useJobProfiles } from "@/queries/use-job-profiles.query.ts";
import { Select } from "@skailer-com/uikit";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

type JobProfileSelectProps = Omit<
  ComponentProps<typeof Select<JobProfileSelectItem>>,
  | "emptyTitle"
  | "isLoading"
  | "onSearchOptions"
  | "options"
  | "searchOptions"
  | "searchable"
  | "showCaption"
> & {
  emptyTitle?: string;
  includeArchived?: boolean;
  isLoading?: boolean;
};

export function JobProfileSelect({
  emptyTitle,
  includeArchived = false,
  isLoading,
  ...props
}: JobProfileSelectProps) {
  const { t } = useTranslation();
  const { options, isLoading: isJobProfilesLoading } = useJobProfiles(includeArchived);

  return (
    <Select
      {...props}
      emptyTitle={emptyTitle ?? t("common:select")}
      isLoading={isLoading ?? isJobProfilesLoading}
      options={options}
      searchable
      showCaption
    />
  );
}
